import React, { useState, useEffect } from 'react';

const BlinkingRobot = ({ onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isBouncing, setIsBouncing] = useState(true);

  // Bounce animation interval
  useEffect(() => {
    const bounceInterval = setInterval(() => {
      setIsBouncing(prev => !prev);
    }, 500);

    return () => clearInterval(bounceInterval);
  }, []);

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-4 left-4 sm:bottom-8 sm:left-8 z-40 group flex items-center gap-2 sm:gap-3"
      data-testid="blinking-robot-chat"
    >
      {/* Air Hostess Container */}
      <div className="relative">
        {/* Glow Effect */}
        <div className={`absolute inset-0 rounded-full bg-gradient-to-r from-red-400 to-pink-500 blur-xl transition-opacity duration-300 ${isHovered ? 'opacity-70' : 'opacity-40'}`} />

        {/* Pulse Animation Ring */}
        <div className="absolute inset-0 rounded-full bg-red-400/30 animate-ping" />

        {/* Air Hostess Icon */}
        <div className={`relative transition-all duration-300 ${isHovered ? 'scale-110' : 'scale-100'} ${isBouncing ? 'translate-y-0' : '-translate-y-1'}`}>
          <div className="w-14 h-14 sm:w-18 sm:h-18 rounded-full bg-white flex items-center justify-center shadow-xl border-3 border-red-400 overflow-hidden">
            <img 
              src="/air-hostess.png" 
              alt="Chat Assistant" 
              className="w-full h-full object-cover"
            />
          </div>
          {/* Online indicator */}
          <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 sm:w-4 sm:h-4 rounded-full bg-green-500 border-2 border-white animate-pulse shadow-lg shadow-green-500/50" />
        </div>
      </div>

      {/* Speech Bubble - Hidden on very small screens */}
      <div className={`hidden xs:block relative bg-white border-2 border-red-400 shadow-xl rounded-2xl px-3 py-2 sm:px-4 sm:py-2.5 transition-all duration-300 ${isHovered ? 'scale-105 shadow-2xl bg-red-50' : 'scale-100'}`}>
        {/* Bubble Arrow */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 w-3 h-3 bg-white border-l-2 border-b-2 border-red-400 rotate-45" />

        {/* Text */}
        <span className="text-xs sm:text-sm font-bold bg-gradient-to-r from-red-600 to-pink-500 bg-clip-text text-transparent whitespace-nowrap">
          Let's get your Business flying
        </span>
      </div>
    </button>
  );
};

export default BlinkingRobot;
